export default __webpack_public_path__ + "static/media/programming-hero-logo.68444d37.png";